import styles from './WidgetOverlayButton.module.scss';

export default function WidgetOverlayButton({
  text,
  ariaLabel,
}: {
  text: string;
  ariaLabel?: string;
}) {
  return (
    <button
      type="button"
      data-testid="widget-overlay-button"
      className={styles.widgetOverlayButton}
      aria-label={ariaLabel || text}
    >
      {text}
    </button>
  );
}
